import ThiCharts from "./thi-charts/thi-charts.vue";
import EditThiSensorModal from "@/components/_modals/edit-thi-sensor";
import { RoleTypes } from "@/constants/role_types";

import { mapState, mapActions } from "vuex";

export default {
  name: "ThiSensorProfile",
  components: { ThiCharts, EditThiSensorModal },
  data() {
    return {
      isModalOpen: false,
      RoleTypes: RoleTypes
    };
  },
  mounted() {
    this.fetchData(this.$route.params.thi_sensor_id);
  },
  methods: {
    ...mapActions("thiSensors", {
      getSensor: "getSensor",
      clearSensor: "clearSensor"
    }),
    async fetchData(thi_sensor_id) {
      await this.clearSensor();
      await this.getSensor({ thi_sensor_id });
    },
    formatValue(value) {
      if (value === null || value === undefined) {
        return this.$t("general.notAvailable");
      }
      return Number(value).toFixed(2);
    },
    editSensor() {
      this.isModalOpen = true;
    }
  },
  computed: {
    canEdit() {
      const user = this.$store.state.user;
      return (
        user !== null &&
        [
          RoleTypes.SuperAdmin,
          RoleTypes.CompanyAdmin,
          RoleTypes.CompanyUserShiftLeader
        ].includes(user.role_type)
      );
    },
    ...mapState({
      profile(state) {
        return state.thiSensors.sensor || {};
      }
    })
  },
  watch: {
    "$route.params.thi_sensor_id": function(newId) {
      if (newId) {
        this.fetchData(newId);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_thi-sensor-profile/thi-sensor-profile.js